import { useState, useEffect } from 'react';
import {
	Checkbox,
	Dialog,
	DialogContent,
	Divider,
	FormControlLabel,
} from '@mui/material';
import i18n from '../../../../../../utils/i18n';
import CustomButton from '../../../../../components/CustomButton';

import TextfieldIcon from '../../../../../components/TextfieldIcon';
import SelectorDual from '../../../../../components/SelectorDual';
import classes from './DialogEditCompany.module.scss';
import SelectorDropdown from '../../../../../components/SelectorDropdown';

import IconTickWhite from '../../../../../../images/icon-tick-white.svg';
import TextfieldUnit from '../../../../../components/TextfieldUnit';
import axios from '../../../../../../shared/axios/axiosProxy';
import { useDispatch } from 'react-redux';
import ACTIONS from '../../../../../../redux/action';
import { TaxformInputByCompanyType } from '../../../../../../provider/data/providerText';

const DialogEditCompany = ({
	openDialogEditCompany,
	setOpenDialogEditCompany,
	providerData,
	companyData,
	selectedId,
}) => {
	const dispatch = useDispatch();
	const [selectedIndustry, setSelectedIndustry] = useState(null);
	const [selectedCompanyForm, setSelectedCompanyForm] = useState(null);
	const [selectedVATStatus, setSelectedVATStatus] = useState(null);
	const [selectedForeignTradeStatus, setSelectedForeignTradeStatus] =
		useState(null);
	const [selectedLanguages, setSelectedLanguages] = useState([]);
	const [newPrice, setNewPrice] = useState('');
	const [saveClicked, setSaveClicked] = useState(false);
	const handleLanguageToggle = (language) => {
		setSelectedLanguages((prevSelected) =>
			prevSelected.includes(language)
				? prevSelected.filter((lang) => lang !== language)
				: [...prevSelected, language]
		);
	};

	const changeHandler = (event) => {
		const newObj = companyData;
		newObj[event.target.id] = event.target.value;

		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: newObj,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	const selectHandler = (id, value) => {
		const newObj = companyData;
		newObj[id] = value;
		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: newObj,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	const dualSelectHandler = (id, value) => {
		//console.log('DUAL SELECT ID', id, 'VALUE', value);
		const newObj = companyData;
		newObj[id] = value;

		if (id === 'foreign_trade' && value === 'false') {
			newObj.foreigntradeEU = '';
		}

		// if (id === 'transfer' && companyData.industryspecifics?.travel) {
		// 	newObj.industryspecifics.travel.travelpayment = {
		// 		...companyData.industryspecifics.travel.travelpayment,
		// 		transfer: value,
		// 	};
		// }

		// if (id === 'card' && companyData.industryspecifics?.travel) {
		// 	newObj.industryspecifics.travel.travelpayment = {
		// 		...companyData.industryspecifics.travel.travelpayment,
		// 		card: value,
		// 	};
		// }

		// if (id === 'benefit' && companyData.industryspecifics?.travel) {
		// 	newObj.industryspecifics.travel.travelpayment = {
		// 		...companyData.industryspecifics.travel.travelpayment,
		// 		benefit: value,
		// 	};
		// }

		// if (id === 'matchingmethod' && companyData.industryspecifics?.travel) {
		// 	newObj.industryspecifics.travel.matchinginvoicestravel = {
		// 		...companyData.industryspecifics.travel.matchinginvoicestravel,
		// 		matchingmethod: value,
		// 		status: value,
		// 	};
		// }

		// if (id === 'transfer' && companyData.industryspecifics?.retail) {
		// 	newObj.industryspecifics.retail.retailpayment = {
		// 		...companyData.industryspecifics.retail.retailpayment,
		// 		transfer: value,
		// 	};
		// }

		// if (id === 'card' && companyData.industryspecifics?.retail) {
		// 	newObj.industryspecifics.retail.retailpayment = {
		// 		...companyData.industryspecifics.retail.retailpayment,
		// 		card: value,
		// 	};
		// }

		// if (id === 'benefit' && companyData.industryspecifics?.retail) {
		// 	newObj.industryspecifics.retail.retailpayment = {
		// 		...companyData.industryspecifics.retail.retailpayment,
		// 		benefit: value,
		// 	};
		// }

		// if (id === 'matchingmethod' && companyData.industryspecifics?.retail) {
		// 	newObj.industryspecifics.retail.matchinginvoicesretail = {
		// 		...companyData.industryspecifics.retail.matchinginvoicesretail,
		// 		matchingmethod: value,
		// 		status: value,
		// 	};
		// }

		// if (id === 'transfer' && companyData.industryspecifics?.wholesale) {
		// 	newObj.industryspecifics.wholesale.wholesalepayment = {
		// 		...companyData.industryspecifics.wholesale.wholesalepayment,
		// 		transfer: value,
		// 	};
		// }

		// if (id === 'card' && companyData.industryspecifics?.wholesale) {
		// 	newObj.industryspecifics.wholesale.wholesalepayment = {
		// 		...companyData.industryspecifics.wholesale.wholesalepayment,
		// 		card: value,
		// 	};
		// }

		// if (id === 'matchingmethod' && companyData.industryspecifics?.wholesale) {
		// 	newObj.industryspecifics.wholesale.matchinginvoiceswholesale = {
		// 		...companyData.industryspecifics.wholesale.matchinginvoiceswholesale,
		// 		matchingmethod: value,
		// 		status: value,
		// 	};
		// }

		// if (id === 'card' && companyData.industryspecifics?.medicine) {
		// 	newObj.industryspecifics.medicine.medicinepayment = {
		// 		...companyData.industryspecifics.medicine.medicinepayment,
		// 		card: value,
		// 	};
		// }

		// if (id === 'benefit' && companyData.industryspecifics?.medicine) {
		// 	newObj.industryspecifics.medicine.medicinepayment = {
		// 		...companyData.industryspecifics.medicine.medicinepayment,
		// 		benefit: value,
		// 	};
		// }

		// if (id === 'matchingmethod' && companyData.industryspecifics?.courier) {
		// 	newObj.industryspecifics.courier.matchinginvoicescourier = {
		// 		...companyData.industryspecifics.courier.matchinginvoicescourier,
		// 		matchingmethod: value,
		// 		status: value,
		// 	};
		// }

		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: newObj,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	const changeHandlerActualStore = (value) => {
		const updatedCompanyData = {
			...companyData,
			industryspecifics: {
				...companyData.industryspecifics,
				etrade: {
					...companyData.industryspecifics.etrade,
					actualstore: {
						...(companyData.industryspecifics?.etrade?.actualstore || {}),
						actualstorecount: value,
						// status: value ? 'true' : 'false',
						status: value && parseInt(value) > 0 ? 'true' : 'false',
					},
				},
			},
		};
		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: updatedCompanyData,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	const updateCourierStatus = (key, value) => {
		const updatedCompanyData = { ...companyData };

		updatedCompanyData.industryspecifics.etrade.etrademultiplecourier[key] =
			value;

		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: updatedCompanyData,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	const changeHandlerCompanycar = (value) => {
		const updatedCompanyData = {
			...companyData,
			industryspecifics: {
				...companyData.industryspecifics,
				general: {
					...companyData.industryspecifics.general,
					companycar: {
						...(companyData.industryspecifics?.general?.companycar || {}),
						carcount: value,
						// status: value ? 'true' : 'false',
						status: value && parseInt(value) > 0 ? 'true' : 'false',
					},
				},
			},
		};
		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: updatedCompanyData,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	const changeHandlerCashregister = (value) => {
		const updatedCompanyData = {
			...companyData,
			industryspecifics: {
				...companyData.industryspecifics,
				general: {
					...companyData.industryspecifics.general,
					cashregister: {
						...(companyData.industryspecifics?.general?.cashregister || {}),
						cashregistercount: value,
						// status: value ? 'true' : 'false',
						status: value && parseInt(value) > 0 ? 'true' : 'false',
					},
				},
			},
		};
		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: updatedCompanyData,
				arrOfObj: 'provider_example_companies',
			})
		);
	};

	// const handleSelectOption = (option: 'individual' | 'smallOffice' | 'office' | 'largeOffice') => {
	//     setSelectedOption(option);
	// };

	const handleCloseDialogEditCompany = () => {
		setOpenDialogEditCompany(false);
	};

	const fetchExampleResult = (companyData, matchScoreWeights, provider_id) => {
		//console.log('PROVIDER FETCH BEGIN');

		const company_req = {
			provider_id: provider_id,
			company_req: companyData,
			match_score_weights: matchScoreWeights,
		};

		return axios
			.post(
				`${process.env.REACT_APP_BACKEND_API}/api/providerexample`,
				company_req,
				{
					'Content-Type': 'application/json',
				}
			)
			.then((response) => {
				let result = response.data.matchingProviders[0].providerContPrice;
				setNewPrice(result);
			})
			.then((resp) => {
				setSaveClicked(true);
				//return resp.data.matchingProviders[0].providerContPrice;
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error);
			});
	};

	const fetchPrice = async (companyData, matchScoreWeights, selectedId) => {
		await fetchExampleResult(companyData, matchScoreWeights, selectedId);
	};

	useEffect(() => {
		setSaveClicked(false);
		if (saveClicked) {
			const updatedData = {
				...companyData,
				accountingprice: newPrice,
			};
			dispatch(
				ACTIONS.updateArrayofObjProviderInfo({
					updatedObj: updatedData,
					arrOfObj: 'provider_example_companies',
				})
			);
		}
	}, [saveClicked]);

	const matchScoreWeights = {
		distanceWeight: 0,
		priceWeight: 0,
		reviewWeight: 3,
		experienceWeight: 0,
		liabilityInsWeight: 0,
		badgeWeight: 0,
		phoneWeight: 0,
		availabilityWeight: 0,
	};

	const handleSave = (companyData, matchScoreWeights, selectedId) => {
		fetchPrice(companyData, matchScoreWeights, providerData.providerID);
		//setOpenDialogEditCompany(false);
	};

	// const inputChangeHandler = (e, item, filterObj, arrObj) => {
	// 	//console.log(e, item, 'ASDASD');
	// 	let tempObj = filterObj.filter((i) => i.id === item.id)[0];
	// 	tempObj.value = parseInt(e.target.value);
	// 	console.log(tempObj, 'tempObj');
	// 	dispatch(
	// 		ACTIONS.updateArrayofObjProviderInfo({
	// 			updatedObj: tempObj,
	// 			arrOfObj: arrObj,
	// 		})
	// 	);
	// };

	return (
		<Dialog
			open={openDialogEditCompany}
			onClose={handleCloseDialogEditCompany}
			PaperProps={{
				sx: {
					width: '420px',
					maxWidth: 'none',
					borderRadius: '18px',
					overflow: 'hidden',
				},
			}}
			sx={{
				'& .MuiDialog-container': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},
				'& .MuiDialog-paper': {
					width: '420px',
					maxWidth: 'none',
				},
			}}>
			<div className={classes.dialogContainer}>
				<div className={classes.dialogTitle}>
					{companyData.name} {i18n.t('provider.editcompanytitle')}
				</div>

				<div className={classes.dialogSubTitle}>
					{i18n.t('provider.editcompanysubtitle')}
				</div>
			</div>

			<Divider />

			<DialogContent
				sx={{
					padding: '0 18px 18px 18px',
					height: '526px',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					overflowY: 'auto',
					scrollbarWidth: 'thin', // Firefox support
					scrollbarColor: '#8791b4 #f1f1f1', // Firefox support

					/* Scrollbar Webkit (Chrome, Safari, Edge) */
					'&::-webkit-scrollbar': {
						width: '10px',
						backgroundColor: '#f1f1f1',
					},
					'&::-webkit-scrollbar-track': {
						backgroundColor: '#e0e0ff',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb': {
						backgroundColor: '#8791b4',
						borderRadius: '10px',
						border: '2px solid #e0e0ff',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						backgroundColor: '#6c7493',
					},
				}}>
				<div className={classes.fullWidth}>
					<TextfieldIcon
						label={i18n.t('general.name')}
						placeholder="-"
						value={companyData.name}
						isRequired={true}
						showAsterix={true}
						id="name"
						onChange={(e) => changeHandler(e)}
					/>

					<Divider sx={{ margin: '18px 0 0 0' }} />

					<SelectorDropdown
						label={i18n.t('companylabels.companyform')}
						options={[
							{
								label: i18n.t('companylabels.singleprimary'),
								value: 'singleprimary',
							},
							{ label: i18n.t('companylabels.kiva'), value: 'kiva' },
							{ label: i18n.t('companylabels.kft'), value: 'kft' },
							{ label: i18n.t('companylabels.zrt'), value: 'zrt' },
							{ label: i18n.t('companylabels.civil'), value: 'civil' },
						]}
						placeholder="-"
						isRequired={false}
						showAsterix={false}
						initialValue={companyData.companytype}
						id="companytype"
						onSelect={(e) => {
							selectHandler('companytype', e.value);
							setSelectedCompanyForm(e.value);
						}}
					/>

					{selectedCompanyForm &&
						selectedCompanyForm !== '' &&
						(selectedCompanyForm === 'singleprimary' ||
							selectedCompanyForm === 'kft' ||
							selectedCompanyForm === 'zrt' ||
							selectedCompanyForm === 'civil' ||
							selectedCompanyForm === 'kiva') && (
							<>
								<SelectorDropdown
									label={i18n.t('provider.taxform')}
									options={TaxformInputByCompanyType(selectedCompanyForm).map(
										(taxForm) => ({
											label: taxForm.label,
											value: taxForm.id,
										})
									)}
									placeholder="-"
									isRequired={false}
									showAsterix={false}
									initialValue={companyData.taxform}
									id="taxform"
									onSelect={(e) => {
										selectHandler('taxform', e.value);
									}}
								/>
							</>
						)}

					<Divider sx={{ margin: '18px 0 18px 0' }} />

					<div className={classes.dialogLabel}>
						{i18n.t('provider.vatpayment')}
					</div>
					<SelectorDual
						initialValue={companyData.vatFilter}
						id="vatFilter"
						options={[
							{ label: i18n.t('general.no'), value: 'false' },
							{ label: i18n.t('general.yes'), value: 'true' },
						]}
						onSelect={(e) => {
							dualSelectHandler('vatFilter', e.value);
							setSelectedVATStatus(e.value);
						}}
					/>

					{selectedVATStatus === 'true' && (
						<>
							<SelectorDropdown
								label={i18n.t('provider.vatpaymentfrequency')}
								options={[
									{ label: i18n.t('general.monthly'), value: 'monthly' },
									{ label: i18n.t('general.quarterly'), value: 'quarterly' },
									{ label: i18n.t('general.yearly'), value: 'yearly' },
									// { label: i18n.t('general.idk'), value: 'idk' }
								]}
								placeholder="-"
								isRequired={false}
								showAsterix={false}
								initialValue={companyData.vatPayment}
								id="vatPayment"
								onSelect={(e) => {
									selectHandler('vatPayment', e.value);
								}}
							/>
						</>
					)}

					<Divider sx={{ margin: '18px 0 0 0' }} />

					<SelectorDropdown
						label={i18n.t('provider.industry')}
						options={[
							{
								label: i18n.t('industrylabels.construction'),
								value: 'construction',
							},
							{ label: i18n.t('industrylabels.engineer'), value: 'engineer' },
							{ label: i18n.t('industrylabels.vehicle'), value: 'vehicle' },
							{
								label: i18n.t('industrylabels.manufacturing'),
								value: 'manufacturing',
							},
							{ label: i18n.t('industrylabels.IT'), value: 'IT' },
							{
								label: i18n.t('industrylabels.realestate'),
								value: 'realestate',
							},
							{ label: i18n.t('industrylabels.retail'), value: 'retail' },
							{ label: i18n.t('industrylabels.wholesale'), value: 'wholesale' },
							{
								label: i18n.t('industrylabels.agriculture'),
								value: 'agriculture',
							},
							{ label: i18n.t('industrylabels.education'), value: 'education' },
							{ label: i18n.t('industrylabels.art'), value: 'art' },
							{ label: i18n.t('industrylabels.medicine'), value: 'medicine' },
							{ label: i18n.t('industrylabels.beauty'), value: 'beauty' },
							{ label: i18n.t('industrylabels.finance'), value: 'finance' },
							{ label: i18n.t('industrylabels.travel'), value: 'travel' },
							{ label: i18n.t('industrylabels.logistics'), value: 'logistics' },
							{ label: i18n.t('industrylabels.etrade'), value: 'etrade' },
							{ label: i18n.t('industrylabels.startup'), value: 'startup' },
							{ label: i18n.t('industrylabels.lawyer'), value: 'lawyer' },
							{ label: i18n.t('industrylabels.courier'), value: 'courier' },
							{ label: i18n.t('industrylabels.sport'), value: 'sport' },
							{
								label: i18n.t('industrylabels.consultancy'),
								value: 'consultancy',
							},
							{
								label: i18n.t('industrylabels.otherservices'),
								value: 'otherservices',
							},
							{ label: i18n.t('industrylabels.other'), value: 'other' },
						]}
						placeholder="-"
						isRequired={false}
						showAsterix={false}
						initialValue={companyData.industry}
						id="industry"
						onSelect={(e) => {
							selectHandler('industry', e.value);
							setSelectedIndustry(e.value);
						}}
					/>

					{/* {selectedIndustry === 'etrade' && (
						<div style={{ marginTop: '8px' }}>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.multiplecourier')}
							</div>
							<div
								style={{
									display: 'grid',
									gridTemplateColumns: 'repeat(2, 1fr)',
									gap: '8px',
								}}>
								{Object.entries(
									companyData.industryspecifics?.etrade
										?.etrademultiplecourier || {}
								).map(([key, value]) => (
									<div
										key={key}
										style={{
											padding: '8px 8px 8px 0',
											border: '1px solid #ccc',
											borderRadius: '8px',
										}}>
										<FormControlLabel
											control={
												<Checkbox
													checked={value}
													onChange={(e) => {
														updateCourierStatus(key, e.target.checked);
													}}
													name={key}
													color='primary'
												/>
											}
											label={i18n.t(`provider.${key}`)}
											componentsProps={{
												typography: {
													style: {
														fontFamily: 'Satoshi, sans-serif',
														fontSize: '12px',
													},
												},
											}}
											style={{
												height: '26px',
												margin: 0,
												display: 'flex',
												alignItems: 'center',
												whiteSpace: 'nowrap',
											}}
										/>
									</div>
								))}
							</div>
						</div>
					)}

					{selectedIndustry === 'etrade' && (
						<div style={{ marginTop: '8px' }}>
							<TextfieldUnit
								title={i18n.t('provider.numberofactualstores')}
								placeholder='-'
								isRequired={false}
								showAsterix={false}
								unit={i18n.t('general.piece')}
								value={
									companyData.industryspecifics?.etrade?.actualstore
										?.actualstorecount || ''
								}
								id='actualstorecount'
								onChange={(e) => changeHandlerActualStore(e.target.value)}
							/>
						</div>
					)}

					{selectedIndustry === 'travel' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.accepttransfers')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.travel?.travelpayment
										?.transfer || 'false'
								}
								id='transfer'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('transfer', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'travel' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.acceptcards')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.travel?.travelpayment?.card ||
									'false'
								}
								id='card'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('card', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'travel' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.acceptbenefits')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.travel?.travelpayment
										?.benefit || 'false'
								}
								id='benefit'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('benefit', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'travel' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.matchinginvoices')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.travel?.matchinginvoicestravel
										?.matchingmethod || 'false'
								}
								id='matchingmethod'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('matchingmethod', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'retail' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.accepttransfers')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.retail?.retailpayment
										?.transfer || 'false'
								}
								id='transfer'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('transfer', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'retail' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.acceptcards')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.retail?.retailpayment?.card ||
									'false'
								}
								id='card'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('card', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'retail' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.matchinginvoices')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.retail?.matchinginvoicesretail
										?.matchingmethod || 'false'
								}
								id='matchingmethod'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('matchingmethod', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'wholesale' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.accepttransfers')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.wholesale?.wholesalepayment
										?.transfer || 'false'
								}
								id='transfer'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('transfer', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'wholesale' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.acceptcards')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.wholesale?.wholesalepayment
										?.card || 'false'
								}
								id='card'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('card', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'wholesale' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.matchinginvoices')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.wholesale
										?.matchinginvoiceswholesale?.matchingmethod || 'false'
								}
								id='matchingmethod'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('matchingmethod', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'medicine' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.acceptcards')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.medicine?.medicinepayment
										?.card || 'false'
								}
								id='card'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('card', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'medicine' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.acceptbenefits')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.medicine?.medicinepayment
										?.benefit || 'false'
								}
								id='benefit'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('benefit', e.value);
								}}
							/>
						</>
					)}

					{selectedIndustry === 'courier' && (
						<>
							<div className={classes.dialogLabel}>
								{i18n.t('provider.matchinginvoices')}
							</div>
							<SelectorDual
								initialValue={
									companyData.industryspecifics?.courier
										?.matchinginvoicescourier?.matchingmethod || 'false'
								}
								id='matchingmethod'
								options={[
									{ label: i18n.t('general.no'), value: 'false' },
									{ label: i18n.t('general.yes'), value: 'true' },
								]}
								onSelect={(e) => {
									dualSelectHandler('matchingmethod', e.value);
								}}
							/>
						</>
					)}*/}

					<Divider sx={{ margin: '18px 0' }} />

					<div className={classes.dialogLabel}>
						{i18n.t('provider.foreigntrade')}
					</div>
					<SelectorDual
						initialValue={companyData.foreign_trade}
						id="foreign_trade"
						options={[
							{ label: i18n.t('general.no'), value: 'false' },
							{ label: i18n.t('general.yes'), value: 'true' },
						]}
						onSelect={(e) => {
							dualSelectHandler('foreign_trade', e.value);
							setSelectedForeignTradeStatus(e.value);
						}}
					/>

					{selectedForeignTradeStatus === 'true' && (
						<>
							<SelectorDropdown
								label={i18n.t('provider.foreignpartners')}
								options={[
									{ label: i18n.t('provider.insideeu'), value: 'inside' },
									{ label: i18n.t('provider.outsideeu'), value: 'outside' },
									{ label: i18n.t('provider.inandoutsideeu'), value: 'both' },
								]}
								placeholder="-"
								isRequired={false}
								showAsterix={false}
								initialValue={companyData.foreigntradeEU}
								id="foreigntradeEU"
								onSelect={(e) => {
									selectHandler('foreigntradeEU', e.value);
								}}
							/>
						</>
					)}

					<Divider sx={{ margin: '18px 0' }} />

					<TextfieldUnit
						title={i18n.t('provider.numberofemployees')}
						placeholder="-"
						isRequired={false}
						showAsterix={false}
						unit={i18n.t('general.person')}
						value={companyData.noofemployees}
						id="noofemployees"
						onChange={(e) => changeHandler(e)}
					/>

					<Divider sx={{ margin: '18px 0 0 0' }} />

					<SelectorDropdown
						label={i18n.t('provider.yearlyrevenue')}
						options={[
							{ label: i18n.t('provider.yearlyrevrange1'), value: '5' },
							{ label: i18n.t('provider.yearlyrevrange2'), value: '10' },
							{ label: i18n.t('provider.yearlyrevrange3'), value: '50' },
							{ label: i18n.t('provider.yearlyrevrange4'), value: '100' },
							{ label: i18n.t('provider.yearlyrevrange5'), value: '200' },
							{ label: i18n.t('provider.yearlyrevrange6'), value: '500' },
							{ label: i18n.t('provider.yearlyrevrange7'), value: '1999' },
							{ label: i18n.t('provider.yearlyrevrange8'), value: '2000' },
						]}
						placeholder="-"
						isRequired={false}
						showAsterix={false}
						initialValue={companyData.yearlyrevenue}
						id="yearlyrevenue"
						onSelect={(e) => {
							selectHandler('yearlyrevenue', e.value);
						}}
					/>

					<Divider sx={{ margin: '18px 0 0 0' }} />

					<SelectorDropdown
						label={i18n.t('provider.monthlyincominginvoices')}
						options={[
							{ label: i18n.t('provider.invoicesrange1'), value: '0' },
							{ label: i18n.t('provider.invoicesrange2'), value: '10' },
							{ label: i18n.t('provider.invoicesrange3'), value: '20' },
							{ label: i18n.t('provider.invoicesrange4'), value: '50' },
							{ label: i18n.t('provider.invoicesrange5'), value: '100' },
							{ label: i18n.t('provider.invoicesrange6'), value: '200' },
							{ label: i18n.t('provider.invoicesrange7'), value: '500' },
							{ label: i18n.t('provider.invoicesrange8'), value: '1000' },
							{ label: i18n.t('provider.invoicesrange9'), value: '2000' },
						]}
						placeholder="-"
						isRequired={false}
						showAsterix={false}
						initialValue={companyData.incominginvoices}
						id="incominginvoices"
						onSelect={(e) => {
							selectHandler('incominginvoices', e.value);
						}}
					/>

					<Divider sx={{ margin: '18px 0 0 0' }} />

					<SelectorDropdown
						label={i18n.t('provider.monthlyoutgoinginvoices')}
						options={[
							{ label: i18n.t('provider.invoicesrange1'), value: '0' },
							{ label: i18n.t('provider.invoicesrange2'), value: '10' },
							{ label: i18n.t('provider.invoicesrange3'), value: '20' },
							{ label: i18n.t('provider.invoicesrange4'), value: '50' },
							{ label: i18n.t('provider.invoicesrange5'), value: '100' },
							{ label: i18n.t('provider.invoicesrange6'), value: '200' },
							{ label: i18n.t('provider.invoicesrange7'), value: '500' },
							{ label: i18n.t('provider.invoicesrange8'), value: '1000' },
							{ label: i18n.t('provider.invoicesrange9'), value: '2000' },
						]}
						placeholder="-"
						isRequired={false}
						showAsterix={false}
						initialValue={companyData.outgoinginvoices}
						id="outgoinginvoices"
						onSelect={(e) => {
							selectHandler('outgoinginvoices', e.value);
						}}
					/>

					{/* <Divider sx={{ margin: '18px 0' }} />

					<TextfieldUnit
						title={i18n.t('provider.numberofcompanycars')}
						placeholder='-'
						isRequired={false}
						showAsterix={false}
						unit={i18n.t('general.piece')}
						value={
							companyData.industryspecifics?.general?.companycar?.carcount || ''
						}
						id='carcount'
						onChange={(e) => changeHandlerCompanycar(e.target.value)}
					/>

					<Divider sx={{ margin: '18px 0' }} />

					<TextfieldUnit
						title={i18n.t('provider.numberofcashregisters')}
						placeholder='-'
						isRequired={false}
						showAsterix={false}
						unit={i18n.t('general.piece')}
						value={
							companyData.industryspecifics?.general?.cashregister
								?.cashregistercount || ''
						}
						id='cashregister'
						onChange={(e) => changeHandlerCashregister(e.target.value)}
					/> */}

					{/* <Divider sx={{ margin: '18px 0' }} /> */}

					{/* <div className={classes.dialogLabel}>
						{i18n.t('provider.environmentalfee')}
					</div>
					<SelectorDual
						options={[i18n.t('general.no'), i18n.t('general.yes')]}
						onSelect={(option) => handleSelectEnviromentalFee(option)}
					/> */}
				</div>
			</DialogContent>

			<Divider />

			<div className={classes.buttonContainer}>
				{/* <CustomButton
					buttonName={i18n.t('general.close')}
					iconSrc={IconCrossGrey}
					onClick={handleCloseDialogEditCompany}
					buttonColor='#ffffff'
					hoverColor='#fafcfe'
					titleColor='#4b5080'
					titleHoverColor='#4b5080'
					width='40%'
					height='44px'
					padding='12px'
					borderColor='#e3e5e9'
					borderWidth='1px'
				/> */}
				<CustomButton
					buttonName={i18n.t('general.close')}
					iconSrc={IconTickWhite}
					onClick={async () => {
						await fetchPrice(
							companyData,
							matchScoreWeights,
							providerData.providerID
						);
						handleCloseDialogEditCompany();
					}}
					buttonColor="#1c32f3"
					hoverColor="#0036cc"
					titleColor="#ffffff"
					titleHoverColor="#e0e0e0"
					width="auto"
					height="44px"
					padding="12px"
				/>
			</div>
		</Dialog>
	);
};

export default DialogEditCompany;
